import $api from "..";
import { AxiosResponse } from "axios";
import { IAddNamedLicenseToUser } from "../common/api_interfaces/license/IAddNamedLicenseToUser";
import { IServerId } from "../common/api_interfaces/license/IServerId";
import { ILicenseRequestStatus } from "../common/api_interfaces/license/ILicenseRequest";
import { ILicenseFunction } from "../common/api_interfaces/license/ILicenseFunction";
import { ILicenseViewVersion } from "../common/api_interfaces/license/ILicenseView";
import { IAvailableModules } from "../common/api_interfaces/license/IAvailableModules";
import { IUpgradeCount } from "../common/api_interfaces/license/IUpgradeCount";
import { IGetNamedLicenses } from "../common/api_interfaces/license/IGetNamedLicenses";
import { UserWithSessions } from "../common/api_interfaces/user/UserWithSessions";

export default class LicenseService {
    async requestLicense(body: ILicenseRequestStatus): Promise<AxiosResponse<void>> {
        return $api.post("/license/request", body);
    }

    async activateLicense(file: File, licenseId?: number): Promise<AxiosResponse<void>> {
        const formData = new FormData();
        formData.append("file", file, encodeURI(file.name));
        if (licenseId) formData.append("licenseId", "" + licenseId);
        return $api.post("/license/activate", formData);
    }

    async getAllLicenses(): Promise<AxiosResponse<ILicenseViewVersion[]>> {
        return $api.get<ILicenseViewVersion[]>(`/licenses`);
    }

    async getLicenseListForChoise(): Promise<AxiosResponse<ILicenseFunction[]>> {
        //Временная мера. Как будет понятно, что Влад отдаёт, доклепаю
        return $api.get("/license/list");
    }

    async getUsersWithSessions(): Promise<AxiosResponse<UserWithSessions>> {
        return $api.get("/user/session");
    }

    async closeUserSessions(sessions: string[]): Promise<AxiosResponse<void>> {
        return $api.post("/user/session/delete", sessions);
    }

    async getAvailableModules(): Promise<AxiosResponse<IAvailableModules>> {
        return $api.get<IAvailableModules>("/license/availableModules");
    }

    async getUpgradeCount(): Promise<AxiosResponse<IUpgradeCount>> {
        return $api.get<IUpgradeCount>("/license/upgradeCount");
    }

    async getServerId(): Promise<AxiosResponse<IServerId>> {
        return $api.get<IServerId>("/license/serverId");
    }

    async getNamedLicenses(): Promise<AxiosResponse<IGetNamedLicenses[]>> {
        return $api.get<IGetNamedLicenses[]>("/license/named");
    }

    async addNamedLicenseUser(body: IAddNamedLicenseToUser): Promise<AxiosResponse<void>> {
        return $api.post<void>("/license/addNamed", body);
    }
}
